import React from 'react';
import { useSelector } from 'react-redux';
import { useChartData } from '../../../../../containers/analyticDashboard/qualityDetails/ncrs/QualityDetailsNCRsCharts';
import { calculateRoundedMax } from '../../../../../modules/data/rounded-max';
import { formatDollars } from '../../../../../modules/format';
import { PACKER_MODE, TIME_RANGE_OPTIONS } from '../../../../../slices/quality-details-ncrs/qualityDetailsNcrsConfig';
import { selectQualityNCRsTimeRange } from '../../../../../slices/quality-details-ncrs/selectors/selectBasicDetailsNcrsData';
import BaseChart from '../../../treasury/BaseChart/BaseChart';
import {
  isLargePropTypes,
  columnsPropTypes,
  colorsPropTypes,
  selectedCategoriesPropTypes,
  selectedSubcategoriesPropTypes,
  packerModePropTypes,
} from '../../../../../slices/quality-details-ncrs/qualityDetailsNcrsPropTypes';
import styles from '../../QualityDetails.module.css';
import { Text } from '@chakra-ui/react';

export default function ClaimDollarsChart(props) {
  const { isLarge, columns, colors, selectedCategories, selectedSubcategories, packerMode } = props;

  const timeRange = useSelector(selectQualityNCRsTimeRange);

  const claimDollarsData = useChartData(
    `claimDollars${packerMode === PACKER_MODE.BOTTOM_10_TOTAL ? 'BottomTen' : ''}`,
    selectedCategories,
    selectedSubcategories
  );

  const total = React.useMemo(() => {
    let sum = 0;
    columns.forEach(x => {
      sum += claimDollarsData.filter(d => !!d).reduce((a, b) => a + b[x], 0);
    });
    return sum;
  }, [claimDollarsData, columns]);

  if (claimDollarsData.length === 0) return null;

  return (
    <div className={styles.QualityDetails_claimDollarsChart}>
      <div className={styles.QualityDetails_chartTitle}>
        <div style={{ color: '#0B1435' }}>Claim dollars</div>
        {timeRange === TIME_RANGE_OPTIONS.HISTORICAL && (
          <div className={styles.QualityDetails_chartTotal}>
            <Text>
              <span style={{ opacity: 0.6 }}>Total</span> <strong>{formatDollars(2)(total || 0)}</strong>
            </Text>
          </div>
        )}
      </div>
      <BaseChart
        barData={claimDollarsData}
        columns={columns}
        colors={colors}
        isLarge={isLarge}
        splitIndex={-1}
        noCurrentLine
        noLegend
        ticksNumber={4}
        formatValues={formatDollars(2)}
        pathColors={colors}
        minMaxGenerator={maxData => {
          return {
            maxVal: calculateRoundedMax(maxData),
            minVal: 0,
          };
        }}
        formatTooltip={formatDollars(2)}
        padding={{ right: 2 }}
        isLineChart
        noLastPoint
        isYearOnYear={timeRange === TIME_RANGE_OPTIONS.YOY}
      />
    </div>
  );
}

ClaimDollarsChart.propTypes = {
  isLarge: isLargePropTypes,
  columns: columnsPropTypes,
  colors: colorsPropTypes,
  selectedCategories: selectedCategoriesPropTypes,
  selectedSubcategories: selectedSubcategoriesPropTypes,
  packerMode: packerModePropTypes,
};
